// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___3YPT5","footerList":"footerList___B32xe","footerListItem":"footerListItem___N8ICQ","logo":"logo___2BSgS","logo__symbol":"logo__symbol___60Un9","logo__hidden":"logo__hidden___2SbiF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Footer/Footer.module.scss
// module id = 2737
// module chunks = 0